import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalProvider } from "@air/provider-modal";
import { ErrorBoundary } from "@air/utils-error";
import classNames from "classnames";
import { memo } from "react";
import { inter } from "~/fonts/inter";
import { ROOT_ELEMENT_ID } from "~/hooks/useMouseSelection";
import { AccountProvider } from "~/providers/AccountProvider";
/**
 * Eventually, after the core split, this component should be removed
 * and all of the shared providers should be moved to _app.tsx
 */ const AppProviderLayout = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("h-full", inter.className, inter.variable),
        id: ROOT_ELEMENT_ID,
        children: /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                children: /*#__PURE__*/ _jsx(ModalProvider, {
                    children: children
                })
            })
        })
    });
});
AppProviderLayout.displayName = "AppProviderLayout";
export const getLayout = (page)=>{
    return /*#__PURE__*/ _jsx(AppProviderLayout, {
        children: /*#__PURE__*/ _jsx(AccountProvider, {
            children: page
        })
    });
};
